import {axiosInstance} from "../boot/axios";

export async function getFillStatus(id) {
    return await axiosInstance.get(`/api/detailed/group-fill/${id}`)
}

export async function getHistoricalDetailedChart(id, period) {
    return await axiosInstance.get(`/api/detailed/${id}/logs?period=${period}`)
}

export async function getHistoricalModalData(id) {
    return await axiosInstance.get(`/api/detailed/${id}/modal`)
}

